export const ROUTE_CONSTANTS = {
  LOGIN: "login",
  ACCOUNT: "account",
  CHECKOUT: "checkout",
  PAYMENT_FAILED: "payment-not-confirmed",
  ORDER_CONFIRMATION: "order-confirmation",
  DELIVERY_ADDRESS: "delivery-address",
  SOCIAL_LOGIN: "/control/googleRedirect",
  PAYMENT_OPTIONS: "payment-options",
  RETRY_PAYMENT: "retry-payment",
};
